<template>
  <div>
    <div class="row mt-1">
      <div class="col-md-4 mb-2">
        <label>{{ trans("examination.diagnosiskPlanedHeadline") }}</label>
        <v-select
          v-model="searchFields.plannedDiagnosisId"
          name="plannedDiagnosisId"
          :options="plannedDiagnoses"
          label="text"
          :reduce="(plannedDiagnosis) => plannedDiagnosis.id"
          :placeholder="trans('examination.externalResourceSelectPlaceholder')"
        />
      </div>

      <div class="col-md-4 mb-2">
        <label>{{
          trans("examination.diagnosisCodeDermatoskopiskLabel")
        }}</label>
        <v-select
          v-model="searchFields.dermatoscopicDiagnosisId"
          name="dermatoscopicDiagnosisId"
          :options="dermatoscopicDiagnoses"
          label="text"
          :reduce="(diagnosis) => diagnosis.id"
          :placeholder="trans('examination.externalResourceSelectPlaceholder')"
        />
      </div>

      <div class="col-md-4 mb-2">
        <label>{{
          trans("examination.diagnosiscodeHistopatologiskLabel")
        }}</label>
        <v-select
          v-model="searchFields.histopathologicalDiagnosisId"
          name="histopathologicalDiagnosisId"
          :options="histopathologicalDiagnoses"
          label="text"
          :reduce="(histoDiagnosis) => histoDiagnosis.id"
          :placeholder="trans('examination.externalResourceSelectPlaceholder')"
        />
      </div>

      <div class="col-md-4 mb-2">
        <label>{{ trans("examination.tagsLabel") }}</label>
        <v-select
          v-model="searchFields.tags"
          name="tags"
          :options="tags"
          label="text"
          :reduce="(tag) => tag.id"
          :placeholder="trans('examination.externalResourceSelectPlaceholder')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["searchFields", "searchOptions"],
  data() {
    return {
      dermatoscopicDiagnoses: [],
      plannedDiagnoses: [],
      histopathologicalDiagnoses: [],
      tags: [],
    };
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      axios
        .get("/api/internal/search/filter-lists/11")
        .then((data) => {
          let collection = data.data;

          this.dermatoscopicDiagnoses = collection.dermatoscopicDiagnoses;
          this.plannedDiagnoses = collection.plannedDiagnoses;
          this.histopathologicalDiagnoses =
            collection.histopathologicalDiagnoses;
          this.tags = collection.tags;
          this.loading = false;
        })
        .catch((error) => {
          this.userErrorMessage(error);
          this.loading = false;
        });
    },
  },
};
</script>
